import { AdvancedBloomFilter, AdvancedBloomFilterOptions } from 'pixi-filters'
import { SeratoFilter } from '@/pixi/filters/types'
import { EffectState } from '@/pixi/filters/types'

export class BloomFilter extends AdvancedBloomFilter implements SeratoFilter {
  protected isDynamicBloomScale: boolean

  constructor (private effectState: EffectState, options?: Partial<AdvancedBloomFilterOptions>) {
    super(options)
    this.isDynamicBloomScale = options?.bloomScale === undefined
    if (!options?.threshold) {
      this.threshold = 0.2 // default value
    }
  }

  public updateUniforms () {
    if (!this.isDynamicBloomScale) {
      return
    }

    const bloomIntensity = this.effectState.audioReactivityEnabled ?
      this.getAudioIntensityValue() : this.effectState.intensity
    this.bloomScale = bloomIntensity * 3 + 0.1
  }

  protected getAudioIntensityValue (): number {
    const bloomIntensityLimit = this.uniforms.intensity
    const adjustedValue = bloomIntensityLimit * this.uniforms.audioPeakAmplitude

    // if the intensity value is less than 50% of the max value, we drop it to 0 to make the effect more visible
    return adjustedValue > bloomIntensityLimit / 2 ? 1 : 0
  }
}
